import React from 'react'
import { getValue } from 'remote-config-value'
import NoAnswerSection from './NoAnswerSection'
import Typography from 'typography'
import { hubspotFormConfig } from './configure_util'
import Button from 'button-mui/src'
import { EditIcon } from 'svg-icons'
import { HotInfoTip } from 'pdc-svg-icons'
import { theme } from 'get-theme'
import Api from 'api'

interface Props {
    classes: any
    selectedScheduleOption: any
    onCallOptionGroups: any
    users: Array<any>
    phoneNumber: string
    showValidationErrors: boolean
    formatUserString: (u: any) => string
    updateOnCallOptionGroups: (a: any) => void
    updateLiveAnswerConfiguration: (a: any) => void
    screenViewType: any
    companyExtension: any
    selectedPlan: any
    callHandlingNotes: string
    liveAnswerConfiguration: any
    lrCollapsed: boolean
    lrModalOpen: boolean
    scriptId: any
    origin: any
    collapseLRModal: () => void
    updateOnChange: boolean
    existingLRNotes: string
    receptionistOption: any
    contactedExpert: boolean
    setContactedExpert: (b: boolean) => void
    updateReceptionistOption: (a: any) => void
    existingLRPlanId: any
    receptionistType: string
}

const receptionistOptions = [
    { id: 'virtual', title: 'Virtual receptionist', description: 'Initial plan $0/month', 'data-test-id': 'virtual-receptionist' },
    { id: 'live', title: 'Live receptionist', description: 'Initial plan: 50 minutes at $90/month, plus applicable fees', 'data-test-id': 'live-receptionist' }
]

const ReceptionistInformationSection = (props: Props): JSX.Element => {
    const { classes } = props
    return (
        <div className={classes.receptionistInformationSection}>
            {(props.origin === 'company-setup' || props.receptionistType === 'virtual')
                ? (
                    <>
                        <Typography variant='body2' className='receptionist-information-section-title' remoteConfigID='configure_number_virtual_receptionist_infotip' />
                    </>
                )
                : (
                    <>
                        <Typography variant='body2' className='receptionist-information-section-title' remoteConfigID='configure_number_receptionist_info' />
                        <br/>
                        <Typography variant='body2' className='receptionist-information-section-title' remoteConfigID='configure_number_receptionist_info_2' />
                    </>
                )}
        </div>
    )
}

const handleSubmit = (setContactedExpert) => {
    setContactedExpert(true)
    Api.submitHubspotForm(hubspotFormConfig.createNew).then(() => {
        console.log('success')
        setContactedExpert(true)
    }).catch(() => {
        console.log('error')
        // set error state
    })
}

const ExpertContactSection = (props: Props): JSX.Element => {
    const { classes } = props
    if (props.receptionistOption === receptionistOptions[1].id && props.contactedExpert) {
        return (
            <div className={classes.expertContact}>
                <img src={theme.icons.smallLogoInfo} className={classes.smallInfoLogo}/>
                <Typography variant='body2' className={classes.expertContactText}>Thank you! We will be in touch shortly.</Typography>
            </div>
        )
    }
    return (
        props.receptionistOption === receptionistOptions[1].id && !props.contactedExpert && (
            <Button onClick={() => handleSubmit(props.setContactedExpert)}>Have an expert call me and tell me more!</Button>
        )
    )
}

const ReceptionistScriptConfiguration = (props: Props): JSX.Element => {
    const { classes } = props
    return (
        <div className={classes.receptionistConfigurationSection}>
            <HotInfoTip color={theme.palette.warning.main} secondaryColor='white' style={{ scale: 1.2 }} />
            <div className={classes.receptionistConfigurationSectionText}>
                <ReceptionistInformationSection {...props} />
                <div className={classes.receptionistSeparator}></div>
                <ExpertContactSection {...props} />
            </div>
        </div>
    )
}

const RenderScriptEditSection = (props: Props): JSX.Element => {
    const { classes, screenViewType } = props
    const moreServicesTabLink = getValue('more_services_tab_link')
    const editScriptLink = `${moreServicesTabLink}/live-receptionist/${props.scriptId}#access_token=${window?.V5PHONECOM?.cp_token}&token_type=Bearer`
    return (
        <div className={`${classes.scriptEditSection} ${screenViewType.isMobileView ? 'mobile' : ''}`}>
            <div className={classes.editNumberColumn}onClick = {() => window.open(editScriptLink, '_blank')}>
                <div className='edit-button'><EditIcon/></div>
                <Typography variant='body2' color='primary' className={classes.scriptEditTitle}>Edit receptionist script</Typography>
            </div>
            <div className={classes.scriptEditText}>
                <Typography variant='body2' className={classes.scriptEditDescription}>{'You\'ll be redirected to Phone.com\'s More Services administration tool to edit your script. You can change your greeting, add contacts, or apply different destination types.'}</Typography>
            </div>
        </div>
    )
}

/**
 *
 * @returns JSX.Element
 * @description This is the Live Receptionist section of the Configure Calling page.
 */
const LiveReceptionistSection = (props: Props): JSX.Element => {
    return (
        <>
            {props.scriptId === -1 && <ReceptionistScriptConfiguration {...props}/>}
            {props.scriptId !== -1 && props.origin !== 'company-setup' && <RenderScriptEditSection {...props}/>}
            <NoAnswerSection {...props} />
        </>
    )
}

export default LiveReceptionistSection
